import {endOfWeek, getWeekOfMonth} from 'date-fns'
import moment from 'moment'

export const convertDateToDayOfWeek = (date: number) => {
  let dictionary: {[x: number]: string} = {
    0: 'Dom',
    1: 'Seg',
    2: 'Ter',
    3: 'Qua',
    4: 'Qui',
    5: 'Sex',
    6: 'Sab',
  }

  return dictionary[date]
}

export const calculatePercent = (items?: number, total?: number) => {
  if (!items || !total) return 0
  return (items / total) * 100
}

export const AGE_GROUPS_WITH_LEGENDS = [
  'Criança (de 0 a 11 anos) ',
  'Adolescente (de 12 a 17 anos)',
  'Jovem (de 18 a 29 anos)',
  'Adulto (de 30 a 59 anos)',
  'Idoso (60 anos ou mais)',
]

export enum GenderEnum {
  MALE = 'Male',
  WOMAN = 'Female',
  UNDETERMINED = 'Undetermined',
}

export function getColorByGender(gender: string) {
  switch (gender) {
    case GenderEnum.MALE:
      return '#4A89DC'
    case GenderEnum.WOMAN:
      return '#B079E6'
    default:
      return '#F5B971'
  }
}

export function translateGender(gender: string) {
  switch (gender) {
    case GenderEnum.MALE:
      return 'Homem'
    case GenderEnum.WOMAN:
      return 'Mulher'
    default:
      return 'Indefinido'
  }
}

export function capitalizeText(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
}

export const DEFAULT_COLORS = [
  '#468FAF',
  '#6D597A',
  '#B56576',
  '#4F759B',
  '#E76F51',
  '#2A9D8F',
  '#F4A261',
  '#8AB17D',
  '#D4A373',
  '#3D5A80',
  '#EE6C4D',
  '#A7C957',
  '#F28585',
  '#8E9AAF',
  '#DDA15E',
  '#94D2BD',
  '#E9C46A',
  '#5E6472',
  '#B5838D',
  '#FFB703',
  '#AC3B61',
  '#5A189A',
  '#E63946',
  '#9B5DE5',
  '#F28482',
  '#457B9D',
  '#E5989B',
]

export const showDateSubtitle = (start: Date, end: Date, amountOnInterval: number) => {
  if (amountOnInterval === 1)
    return `${start.toLocaleString('pt-br', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })}`

  if (start.getMonth() !== end.getMonth())
    return `${start.toLocaleString('pt-br', {
      day: '2-digit',
      month: 'short',
    })} a ${end.toLocaleString('pt-br', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })} `

  return `${start.toLocaleString('pt-br', {
    day: '2-digit',
  })} a ${end.toLocaleString('pt-br', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })} `
}

export const translateWeekDays: {[key: string]: string} = {
  Sunday: 'Dom',
  Monday: 'Seg',
  Thursday: 'Qui',
  Wednesday: 'Qua',
  Tuesday: 'Ter',
  Friday: 'Sex',
  Saturday: 'Sab',
}

export const transformIntoPositiveNumber = (number: number) => {
  return number < 0 ? number * -1 : number
}

export const calculateIncreasePercentage = (total: number, value: number) => {
  if (value === 0) return 0
  const percentage = ((total - value) / value) * 100
  return Number(percentage.toFixed(0))
}

export const calculateAverage = (value: number, amount: number) => {
  const average = value / amount
  return Number(average.toFixed(0))
}

export const weekOrder = ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom']

export const formatWeekOnLabel = (data: Array<string | Date>, type: string) => {
  if (type === 'week') {
    const weeks = data.map((it) => {
      const date = String(it).replace('T00', 'T03')
      const startDate = new Date(date)
      const endDate = endOfWeek(startDate)
      const week = getWeekOfMonth(startDate)
      const formattedDate = `${moment(date).format('DD')} a ${endDate.toLocaleString('pt-br', {
        day: '2-digit',
        month: 'short',
      })} - Semana ${week}`
      return formattedDate
    })

    return weeks
  }
  return data
}
